import { isMobileBreakpoint } from "@utils/responsive";
import { TweenMax } from "gsap/all";

const scrollTo = () => {
    const links = document.querySelectorAll("a");
    links.forEach(each => (each.onclick = scrollAnchors));
};

function scrollAnchors(e, respond = null) {
    var targetID = respond
        ? respond.getAttribute("href")
        : this.getAttribute("href");
    if (targetID) {
        targetID = "#" + targetID.split("#")[1];

        const targetAnchor = document.querySelector(targetID);

        if (targetAnchor) {
            e.preventDefault();
            const mobileNavOffset = 115;
            const desktopNavOffset = 88;
            const navOffset = isMobileBreakpoint()
                ? mobileNavOffset
                : desktopNavOffset;
            TweenMax.to(window, 200 / 1000, {
                scrollTo: {
                    y: targetAnchor,
                    offsetY: navOffset,
                    autoKill: false,
                },
            });
        }
    }
}

export default scrollTo;
